/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Signed_AtInputs */

const cs_field_signed_at = /** @type {(inputs: Field_Signed_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podepsáno dne`)
};

const en_field_signed_at = /** @type {(inputs: Field_Signed_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed at`)
};

/**
* | output |
* | --- |
* | "Signed at" |
*
* @param {Field_Signed_AtInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_signed_at = /** @type {((inputs?: Field_Signed_AtInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Signed_AtInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_signed_at(inputs)
	return cs_field_signed_at(inputs)
});